import { defineComponent as y, createBlock as f, openBlock as t, withCtx as e, createElementBlock as l, createVNode as a, unref as u, createTextVNode as n, Fragment as i, renderList as b, toDisplayString as p } from "vue";
import g from "../../../components/DataTable/DataTable.vue.js";
import c from "../../../components/DataTable/DataTableRow.vue.js";
import _ from "../../../components/DataTable/DataTableText.vue.js";
import k from "../../../components/HelpfulLink.vue.js";
import w from "../../../components/ViewLayout/ViewLayoutCollapse.vue.js";
import { httpHeaders as h } from "../../../data/httpHeaders.js";
import x from "../../../components/DataTable/DataTableHeader.vue.js";
const H = {
  key: 0,
  class: "max-h-[calc(100%-32px)] overflow-y-auto"
}, C = {
  key: 1,
  class: "text-c-3 bg-b-1 flex min-h-12 items-center justify-center rounded border px-4 text-base"
}, T = /* @__PURE__ */ y({
  __name: "ResponseHeaders",
  props: {
    headers: {}
  },
  setup(v) {
    const m = (s) => h.find(
      (r) => r.name.toLowerCase() === s.toLowerCase()
    );
    return (s, r) => (t(), f(w, {
      class: "overflow-auto",
      defaultOpen: !1,
      itemCount: s.headers.length
    }, {
      title: e(() => r[0] || (r[0] = [
        n("Response Headers")
      ])),
      default: e(() => [
        s.headers.length ? (t(), l("div", H, [
          a(g, {
            columns: ["minmax(auto, min-content)", "minmax(50%, 1fr)"],
            scroll: ""
          }, {
            default: e(() => [
              a(c, { class: "sr-only !block" }, {
                default: e(() => [
                  a(u(x), null, {
                    default: e(() => r[1] || (r[1] = [
                      n("Header Key")
                    ])),
                    _: 1,
                    __: [1]
                  }),
                  a(u(x), null, {
                    default: e(() => r[2] || (r[2] = [
                      n("Header Value")
                    ])),
                    _: 1,
                    __: [2]
                  })
                ]),
                _: 1
              }),
              (t(!0), l(i, null, b(s.headers, (o) => (t(), f(c, {
                key: o.name,
                class: "group/row text-c-1"
              }, {
                default: e(() => [
                  a(_, { class: "bg-b-1 sticky left-0 z-1 max-w-48 group-first/row:border-t-0" }, {
                    default: e(() => {
                      var d;
                      return [
                        typeof ((d = m(o.name)) == null ? void 0 : d.url) == "string" ? (t(), f(k, {
                          key: 0,
                          class: "decoration-c-3",
                          href: m(o.name).url
                        }, {
                          default: e(() => [
                            n(p(o.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["href"])) : (t(), l(i, { key: 1 }, [
                          n(p(o.name), 1)
                        ], 64))
                      ];
                    }),
                    _: 2
                  }, 1024),
                  a(_, {
                    class: "z-0 group-first/row:border-t-0",
                    text: o.value
                  }, null, 8, ["text"])
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          })
        ])) : (t(), l("div", C, " No Headers "))
      ]),
      _: 1
    }, 8, ["itemCount"]));
  }
});
export {
  T as default
};
